import { useEffect, useRef } from 'react'
import { SALESFORCE_ACTION_HUB_REFRESH_EVENT } from '../salesforceResourceBroker'

type ResourceType = 'offer' | 'reseller-auth'

// Listens for the broker CustomEvent (same-window, fired by emitSalesforceResourceSaved)
// and closes the Salesforce modal only when a FINAL save completes (not draft saves).
// No partnerId check needed: the CustomEvent is same-window so there is no cross-partner risk.
export const useCloseSalesforceModalAfterSave = ({
  resourceType,
  closeModal,
}: {
  resourceType: ResourceType
  closeModal?: () => void
}) => {
  const hasClosedRef = useRef(false)

  useEffect(() => {
    if (!closeModal) return

    const handler = (event: Event) => {
      if (hasClosedRef.current) return
      const payload = (event as CustomEvent).detail
      if (payload?.resourceType !== resourceType) return

      // Draft saves should refresh the action hub list but keep the modal open.
      const resourceObj =
        resourceType === 'offer' ? payload.offer : payload.resellerAuthorization
      if (resourceObj?.draft) return

      hasClosedRef.current = true
      closeModal()
    }

    window.addEventListener(SALESFORCE_ACTION_HUB_REFRESH_EVENT, handler)
    return () => {
      window.removeEventListener(SALESFORCE_ACTION_HUB_REFRESH_EVENT, handler)
    }
  }, [resourceType, closeModal])
}
